// 🔧 store_generator.js
// ✅ Purpose: Generates Event Merch Store demo data
// ✅ Features:
// - Generates realistic event merchandise products
// - Generates product variants
// - Scales product count by demo size
// - No Firestore writes
// - No DemoContext mutation
// - Fully block-commented for clarity and future devs

import { buildStoreDefaults } from "./templates/store_defaults";

export const generateStore = ({ demoContext } = {}) => {
  console.log("🛒 Store Generator started.");

  const industryTemplate =
    demoContext?.industryTemplate?.key ||
    demoContext?.demoConfig?.industry ||
    "car_show";

  const demoSize =
    demoContext?.demoConfig?.size ||
    demoContext?.seedProfile?.demoSize ||
    "medium";

  const storeData = buildStoreDefaults({
    industryTemplate,
    demoSize,
  });

  console.log("✅ Store Generator completed.", {
    products: storeData.products.length,
    variants: storeData.variants.length,
    industryTemplate,
    demoSize,
  });

  return storeData;
};
